import {
    h,
    renderSlot,
} from 'vue'

import './css/style.scss'

const ABadge = {
    name: 'ABadge',
    props: {
        alt: {
            type: Boolean,
            default: false
        },
        params:{
            type: Object,
            default: {}
        },
        link: {
            type: String,
            default: ''
        },
    },
    setup: (props, ctx) => {
        const getChildren = () => {
            let result = [];

            if(props?.params?.link) {
                let child = h('span', { class: 'a-badge-value'}, renderSlot(ctx.slots, 'default'));
                if(props?.params?.img) {
                    child = h('span', { class: 'a-badge-value img',style:'background-image:url("'+props.params.img+'")'});
                }
                result.push(
                    h(
                        'a',
                        {class: ['a-badge-inner'], href:props.params.link},
                        child
                    )
                );
            } else {
                result.push(h('div', {
                        class: ['a-badge-inner']
                    }, h('span', { class: 'a-badge-value'}, renderSlot(ctx.slots, 'default'))
                ));
            }
            return result;
        };
        const render = () => h('div', {
            ...ctx.attrs,
            class: [
                'a-badge',
                ctx.attrs.class,
                {'a-badge--alt': props.alt}
            ],
        }, getChildren())

        return () => render()
    }
}

export {
    ABadge
}